// ***************************************************************
// This array controls the internal roles valid to designate
// the user as part of the inernal sales team
// ***************************************************************

export const internalRoles = ['rep', 'manager', 'exec_manager']

export const managerRoles = ['manager', 'exec_manager']

export const userRoles = ['user', 'admin']

export const elevatedUserNames = ['MZAVATTI']